<template>
  <div id="reservation-error">
    <div id="reservation-error-message">{{ errorMessage }}</div>
    <div id="reservation-error-call-to-action">Please call our restaurants directly during restaurant hours.</div>
    <div class="restaurant-phone">For <span class="location">Greensboro</span>, please call 336-299-1003. <a class="button" href="tel:3362991003">Call Greensboro</a></div>
    <div class="restaurant-phone">For <span class="location">Winston</span>, please call 336-765-7798. <a class="button" href="tel:3367657798">Call Winston</a></div>
  </div>
</template>

<script>

export default {
  name: 'reservationError',
  components: {

  },
  props: [ 'errorMessage' ],
  data() {
    return {

    }
  },
  computed: {

  },
  methods: {

  }

}

</script>

<style lang="scss" scoped>

#reservation-error {
  margin: 20px;

  @media screen and (max-width: 768px) {
    margin: 3px;
  }
}

#reservation-error-message {
  font-weight: bold;
  width: 100%;
}

#reservation-error-call-to-action {
  width: 100%;
}

.restaurant-phone {
  width: 100%;
  margin: 15px 0;
}



</style>